import React from "react";
import { FaInfoCircle, FaCheckCircle } from "react-icons/fa";

const EventPolicies = ({ dynamicPolicies = [] }) => {
  const defaultPolicies = [
    {
      title: "Participant Count",
      desc: "Package limits apply to participating guests. Non-participating parents, guardians, and spectators do not count toward the participant limit, subject to facility capacity.",
    },
    {
      title: "Sport Selection",
      desc: "All-Star Squad and Big League include one sport. Additional sports may be available for an additional charge, subject to scheduling and facility availability.",
    },
    {
      title: "Playing Area",
      desc: "Strikes & Shots will assign the appropriate field or court based on the selected sport, group size, scheduling, and facility availability.",
    },
    {
      title: "Food & Beverages",
      desc: "Outside food and beverages are not permitted, with the exception of birthday cakes or cupcakes. Food and beverage packages may be added to any event.",
    },
    {
      title: "Party Supplies",
      desc: "Paper plates, cups, napkins, and utensils are not included in base packages unless food and beverage packages are purchased through Strikes & Shots.",
    },
    {
      title: "Facility Availability",
      desc: "All packages, field/court space, and party areas are subject to availability at the time of booking. Early reservation is recommended.",
    },
    {
      title: "Waiver Requirement",
      desc: "All participants must have a signed electronic waiver completed prior to participating in any sports or activities at Strikes & Shots.",
    },
    {
      title: "Large Groups",
      desc: "For groups of 25 or more participants, contact Strikes & Shots for customized pricing, space, and staffing requirements.",
    },
  ];

  const displayPolicies =
    dynamicPolicies && dynamicPolicies.length > 0
      ? dynamicPolicies
      : defaultPolicies;

  return (
    <div
      id="policies"
      className="w-full py-16 sm:py-20 px-4 md:px-8 lg:px-12 bg-white select-none text-gray-800 border-t border-gray-100"
    >
      <div className="max-w-7xl mx-auto flex flex-col items-center">
        {/* Section Header */}
        <div className="flex flex-col items-center text-center mb-10 sm:mb-12">
          <div className="w-12 h-12 rounded-2xl bg-red-50 border border-primaryBtnHoverColor/20 text-primaryBtnHoverColor flex items-center justify-center text-xl mb-3.5 shadow-sm">
            <FaInfoCircle />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-black text-primaryBtnColor uppercase tracking-tight">
            IMPORTANT NOTICE &amp; POLICY
          </h2>
          <p className="mt-2.5 text-gray-600 font-subheading text-sm sm:text-base max-w-2xl leading-relaxed">
            Key details regarding participant counts, court assignments, party supplies, and booking policies.
          </p>
        </div>

        {/* Policy Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 w-full text-xs sm:text-sm font-subheading">
          {displayPolicies.map((note, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 p-5 sm:p-6 rounded-2xl bg-white border border-gray-200 shadow-xs hover:shadow-md hover:border-primaryBtnHoverColor/40 transition-all duration-200"
            >
              <div className="w-7 h-7 rounded-full bg-red-50 text-primaryBtnHoverColor border border-red-100 flex items-center justify-center flex-shrink-0 mt-0.5 text-xs shadow-2xs">
                <FaCheckCircle />
              </div>
              <div>
                <strong className="text-gray-900 font-heading font-bold text-sm sm:text-base block mb-1">
                  {note.title}:
                </strong>
                <span className="text-gray-600 leading-relaxed text-xs sm:text-sm">
                  {note.desc}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventPolicies;
